// extracted by mini-css-extract-plugin
export default {"requestListMobile":"request-list-mobile_requestListMobile__14vQU"};